import { PlatformMapLoadingState } from './types'

const ALLOWED_TRANSITIONS: Record<PlatformMapLoadingState, PlatformMapLoadingState[]> = {
  IDLE: ['BOOTING'],
  BOOTING: ['INITIAL_IMAGERY', 'ERROR'],
  INITIAL_IMAGERY: ['READY', 'ERROR'],
  BASEMAP_SWAPPING: ['READY', 'ERROR'],
  CAMERA_MOVING: ['REFINING', 'READY', 'ERROR'],
  REFINING: ['CAMERA_MOVING', 'READY', 'ERROR'],
  RESUMING: ['READY', 'RECOVERING_WEBGL', 'ERROR'],
  RECOVERING_WEBGL: ['READY', 'ERROR'],
  READY: ['BASEMAP_SWAPPING', 'CAMERA_MOVING', 'RESUMING', 'RECOVERING_WEBGL', 'ERROR'],
  ERROR: ['BOOTING', 'RECOVERING_WEBGL']
}

export class MapLoadingStateMachine {
  private currentState: PlatformMapLoadingState = 'IDLE'
  private listeners = new Set<(state: PlatformMapLoadingState) => void>()

  get state () {
    return this.currentState
  }

  transition (nextState: PlatformMapLoadingState, force = false) {
    if (nextState === this.currentState) return
    const allowed = ALLOWED_TRANSITIONS[this.currentState] || []
    if (!force && !allowed.includes(nextState)) {
      throw new Error(`非法地图加载状态转换: ${this.currentState} -> ${nextState}`)
    }
    this.currentState = nextState
    this.listeners.forEach(listener => listener(nextState))
  }

  subscribe (listener: (state: PlatformMapLoadingState) => void) {
    this.listeners.add(listener)
    listener(this.currentState)
    return () => this.listeners.delete(listener)
  }
}
